module.exports = __webpack_public_path__ + "public/SideMenuIcons/managePayout.svg?ee98cb1a";